import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const downloadAllQrLogs = createAsyncThunk( "qrScanLog/downloadAll",
  async (params, { rejectWithValue }) => {
    try {
      const apiParams = {
        servicetype: params.qr_type || undefined,
        date_start: params.date || undefined,
        date_end: params.date || undefined,
        department: params.department || undefined,
        keyword: params.keyword || undefined
      };

      const response = await axiosHttp.get(`lcqr/downloadallqrlogs`, {
        responseType: 'blob',
        params : apiParams
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Something went wrong");
    }
  }
);

const qrAllLogsDownloadSlice = createSlice({
  name: "qrAllLogsDownload",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadAllQrLogs.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadAllQrLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(downloadAllQrLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default qrAllLogsDownloadSlice.reducer;
